<newsletter-svg-sprite />

@if (newsletter(); as nl) {
  <div [formGroup]="form" class="newsletter-form" [style.background]="brand()?.primaryColor"
    [class.popup]="mode() === 'popup'" [class.home-page]="mode() === 'home-page'">
    <div class="container">
      <h3 class="page-title">{{nl.callToAction ? nl.callToAction :
      ('newsLetter.subscribeToOurNewsletter' | translate)}}</h3>
      <div class="spam-msg d-flex justify-content-center align-items-center">
        <div class="icon">
          <svg>
            <use xlink:href="#unsubscribeIcon"></use>
          </svg>
        </div>
        <span class="spam-msg-txt">{{nl.infoNote ? nl.infoNote : ('newsLetter.defaultDisclaimer' |
          translate)
        }}</span>
      </div>
      <div class="email-wrapper d-flex align-items-center">
        <div class="form-group w-100">
          <input type="text" class="form-control" placeholder="{{('newsLetter.enterYourEmail' | translate)}}"
            formControlName="email">
        </div>
        <!-- In the popup the whole card is painted with the brand primary colour, and .btn-accent
             is painted with the (often identical) brand accent - so the button vanished into the
             background. Give the popup button a white fill with brand-coloured text for clear
             contrast against any brand colour. (Inline styles override the themed .btn-accent bg.) -->
        <button class="btn-accent" [class.popup-cta]="mode() === 'popup'"
          [style.background]="mode() === 'popup' ? '#fff' : null"
          [disabled]="subscribed()" (click)="saveEmail()">
          <span [style.color]="mode() === 'popup' ? (brand()?.primaryColor || '#4B29CC') : null">{{ 'newsLetter.subscribe' | translate }}</span>
        </button>
      </div>
      <div class="checkbox-container d-flex align-items-center">
        <div class="form-checkbox">
          <input formControlName="checkbox" type="checkbox" class="form-checkbox-input"
            [style.accent-color]="brand()?.accentColor" #consentWarning>
        </div>
        <span class="consent-warning noselect" (click)="toggle(consentWarning)">
          {{nl.consentWarning ? nl.consentWarning : ('newsLetter.defaultConsentNotice' | translate)}}
        </span>
      </div>
    </div>
    <img class="bg-send-img" [src]="newsletterUrl" alt="">
  </div>
}
